import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H4 } from 'foundations-components/transitional/components/H4';
import { REJECTED_APPROVAL_ONLY_TO_CLOSED_LOST } from 'customer-data-properties/input/pipeline/utils/pipelineValidationTypes';
import { useCallback } from 'react';
import { useTriggerOverlay } from '../../handlers/useTriggerOverlay';
import { useLogger } from 'crm-object-board-core/logger';
import { useObjectTypeDefinitionTranslationOptions } from 'crm-object-board-core/objectTypeDefinition';
import { useCloseOverlay } from '../../overlay/OverlayContainer';
import { FormattedErrorMessage } from './FormattedErrorText';
import { loadCSATSurvey } from '../../utils/feedback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const REVIVE_REJECTED_DEAL_SURVEY_ID_PROD = 1218;
const REVIVE_REJECTED_DEAL_SURVEY_ID_QA = 464;
const ConfirmBypassStageValidationModal = props => {
  const closeOverlay = useCloseOverlay();
  const logger = useLogger();
  const handleCancel = useCallback(() => {
    props.onCancel();
    closeOverlay();
  }, [props, closeOverlay]);
  const handleConfirm = useCallback(() => {
    props.onConfirm();
    if (props.errorCode === REJECTED_APPROVAL_ONLY_TO_CLOSED_LOST) {
      logger.log({
        key: 'boardMoveRejectedRevive',
        metadata: {
          statusCode: props.errorCode
        }
      });
      loadCSATSurvey({
        qaId: REVIVE_REJECTED_DEAL_SURVEY_ID_QA,
        prodId: REVIVE_REJECTED_DEAL_SURVEY_ID_PROD
      });
    } else {
      logger.log({
        key: 'boardMoveByPass',
        metadata: {
          statusCode: props.errorCode
        }
      });
    }
    closeOverlay();
  }, [props, logger, closeOverlay]);
  const options = useObjectTypeDefinitionTranslationOptions();
  return /*#__PURE__*/_jsxs(Modal, {
    width: 450,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedErrorMessage, {
          messageRoot: `crmObjectBoard.governance.bypassTitle`,
          errorCode: props.errorCode,
          options: options
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleCancel
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedErrorMessage, {
          messageRoot: `crmObjectBoard.governance.bypassDescription`,
          errorCode: props.errorCode,
          options: options
        })
      }), props.errorCode === REJECTED_APPROVAL_ONLY_TO_CLOSED_LOST && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `crmObjectBoard.governance.bypassAdmin`
        })
      }), /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.governance.bypassConfirm"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.governance.bypassConfirmButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: handleCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.governance.bypassCancelButton"
        })
      })]
    })]
  });
};
export const useOpenConfirmBypassStageValidationModal = () => {
  const trigger = useTriggerOverlay();
  return useCallback(options => {
    const overlay = () => /*#__PURE__*/_jsx(ConfirmBypassStageValidationModal, Object.assign({}, options));
    trigger(overlay);
  }, [trigger]);
};